<div class="dob-group">
  <span>
    For example, 27 12 1977
  </span>
  <div #wrapperDiv [id]="id" class="d-flex mt-2" [formlyAttributes]="field" [class.is-invalid]="isInvalid()"
    [class.is-valid]="isValid()" [attr.aria-describedby]="errorId + ' ' + errorDescriptionId">
    <div class="date-col">
      <label class="font-weight-bold" for="day">Day</label>
      <input type="text" id="day" name="day" maxlength="2" class="form-control form-control-lg"
        (keyup)="onKeyup($event, 'month')" (keydown)="onKeydown($event, 'day')" (blur)="onBlur('day')" placeholder="DD"
        #dayControl="ngModel" [ngModel]="dateModel.day" (ngModelChange)="updateModel($event, 'day')" />
    </div>
    <div class="date-col">
      <label class="font-weight-bold" for="month">Month</label>
      <input type="text" id="month" name="month" maxlength="2" class="form-control form-control-lg"
        (keyup)="onKeyup($event, 'year')" (keydown)="onKeydown($event, 'month')" (blur)="onBlur('month')"
        placeholder="MM" #monthControl="ngModel" [ngModel]="dateModel.month"
        (ngModelChange)="updateModel($event, 'month')" />
    </div>
    <div class="date-col">
      <label class="font-weight-bold" for="year">Year</label>
      <input type="text" id="year" name="year" maxlength="4" class="form-control form-control-lg"
        (keyup)="onKeyup($event, null)" (keydown)="onKeydown($event, null)" (blur)="onBlur('year')"
        #yearControl="ngModel" [ngModel]="dateModel.year" placeholder="YYYY"
        (ngModelChange)="updateModel($event, 'year')" />
    </div>
  </div>
</div>

<div id="{{ errorDescriptionId }}" class="sr-only">
  {{ valid ? 'valid input' : '' }}
  {{ invalid ? 'invalid input' : '' }}
</div>

@if (showError && !props.suppressErrors) {
  <div class="invalid-feedback alert alert-danger mt-2 d-flex" [style.display]="'block'">
    <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
    <formly-validation-message class="ms-3" [id]="id + '-error-description-id'" [field]="field"></formly-validation-message>
  </div>
}
